module.exports = __webpack_public_path__ + "img/WordcloudAch.6fdfaf0e.png";